export default {
  pageTitle: 'Home',
  getJoke: 'Get a joke',
};
